<template lang="html">
  <newsarticle :article="article || page" v-if="article || page"></newsarticle>
  <issue-article :article="issue" v-else-if="issue"></issue-article>
  <chapter :data="chapter" v-else-if="chapter"></chapter>
  <div v-else style="height: 10000px;"></div>
</template>

<script>
import getSanityDocument from '@/getSanityDocument'
import router from '@/router'
import NewsArticle from '@/components/NewsArticle'
import Chapter from '@/pages/Chapter'
import IssueArticle from '@/components/IssueArticle'

export default {
  components: {
    'newsarticle': NewsArticle,
    'chapter': Chapter,
    IssueArticle
  },
  data () {
    return {
      article: null,
      page: null,
      issue: null,
      chapter: null,
      currentSlug: this.$route.params.slug
    }
  },
  created () {
    getSanityDocument(this.$route.params.slug).then(document => {
      this.setData(document)
    })
  },
  watch: {
    '$route.params.slug': function () {
      getSanityDocument(this.$route.params.slug).then(document => {
        this.setData(document)
      })
    }
  },
  // beforeRouteEnter (to, from, next) {
  //   console.log('beforeRouteEnter')
  //   getSanityDocument(to.params.slug).then(document => {
  //     next(app => app.setData(document))
  //   })
  // },
  methods: {
    setData (document) {
      if (!document || !document._type) {
        router.replace({path: '/404'})
      } else {
        switch (document._type) {
          case 'article':
            this.article = document
            break
          case 'issue':
            this.issue = document
            break
          case 'page':
            this.page = document
            break
          case 'lag':
            this.chapter = document
            break
        }
      }
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/MainPage.vue